module.exports = __webpack_public_path__ + "img/icon_kalinba_download_code.b81d4a0e.png";